import React, { useState} from "react";
import Wrapper from "../../components/Wrapper";
import InnerNav from "../../components/InnerNav";
import { FiSave } from "react-icons/fi";
import axios from 'axios';
import { Navigate } from "react-router-dom";
 
const WithdrawalRequestCreate = ()=>{
     const [msisdn, setMsisdn ] = useState('');
     const [amount, setAmount ] = useState('');
     const [sourceIp, setSourceIp ] = useState('');
     const [transactionId, setTransactionId ] = useState('');
     const [approved, setApproved ] = useState('');
     const [sent, setSent ] = useState('');
     const [apiResponse, setApiResponse ] = useState('');
     const [redirect, setRedirect] = useState(false);
     const submit = async (e)=>{
         e.preventDefault();
         const {data} = await axios.post('withdrawalRequest', {
            msisdn,
            amount,
            sourceIp,
            transactionId,
            approved,
            sent,
            apiResponse,
        });
        console.log(data);
        setRedirect(true);
     }
    if(redirect){
        return <Navigate to={'/withdrawalRequest'} />
    }
     return (
         <Wrapper pageTitle={"New WithdrawalRequest"}>
            <InnerNav createLink={'/withdrawalRequestCreate'} listLink={'/withdrawalRequest'} />
             <form onSubmit={submit}>
                <div className="px-4 py-3 mb-8 bg-white rounded-lg shadow-md dark:bg-gray-800" >
                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Msisdn </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Msisdn"
                        onChange = {e => setMsisdn(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Amount </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Amount"
                        onChange = {e => setAmount(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">SourceIp </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="SourceIp"
                        onChange = {e => setSourceIp(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">TransactionId </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="TransactionId"
                        onChange = {e => setTransactionId(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Approved </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Approved"
                        onChange = {e => setApproved(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Sent </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Sent"
                        onChange = {e => setSent(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">ApiResponse </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="ApiResponse"
                        onChange = {e => setApiResponse(e.target.value)} />
                    </label>

                    <div className="flex mt-6 text-sm">
                        <label className="flex items-center dark:text-gray-400">
                        <button className="flex items-center justify-between px-4 py-2 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-blue-600 border border-transparent rounded-lg active:bg-white hover:bg-blue-400 focus:outline-none focus:shadow-outline-purple"
                        onClick={submit}
                        > <FiSave /> <span className="ml-3">Save</span> </button>
                        </label>
                    </div>
                </div>
             </form>
        </Wrapper>
     );
};
export default WithdrawalRequestCreate;